<template>
  <ImageHeader :headerTitle="$t('views.overview.title.orderOverview')" :imageSource="require('../assets/leeb-images3/pic1.jpg')">
    <v-row>
      <v-col lg="6" cols="12">
        <v-card style="height: 100%;" data-voverviewtourstep="1" elevation="0">
          <v-card-text>
            <h3 class="primary--text">
              {{ $t('views.overview.baseData') }}
            </h3>
            <v-skeleton-loader v-if="!masterOrderLoaded" type="text" class="mt-3"></v-skeleton-loader>
            <v-list ense v-else>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <span>{{ getCustomerAddressation(masterOrder.Customer) }} (<abbr :title="$t('views.overview.customerNumberExplanation')">{{ $t('views.overview.customerNumberAbbreviated') }}</abbr>:
                    {{ masterOrder.Customer.CustomerNumber }})</span>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-skeleton-loader v-if="!masterOrderLoaded" type="list-item-two-line"></v-skeleton-loader>
            <v-list dense v-else>
              <v-list-item v-for="communicationEntry in masterOrder.Customer.Communications"
                v-bind:key="communicationEntry.Id" dense>
                <v-list-item-icon>
                  <v-icon v-if="communicationEntry.CommunicationTypeId == 2">mdi-phone</v-icon>
                  <v-icon v-else-if="communicationEntry.CommunicationTypeId == 5">mdi-cellphone</v-icon>
                  <v-icon v-else-if="communicationEntry.CommunicationTypeId == 1">mdi-email</v-icon>
                  <v-icon v-else>mdi-email</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  {{ communicationEntry.Value }}
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <br>
            <b>{{ $t("views.overview.paymentAddress") }}</b>
            <v-skeleton-loader v-if="!masterOrderLoaded" type="list-item"></v-skeleton-loader>
            <v-list dense v-else>
              <v-list-item v-if="invoiceAddresses.length > 0">
                <v-list-item-icon>
                  <v-icon>mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{ invoiceAddresses[0].Street }}<br>{{ invoiceAddresses[0].Country.CountryCodeIso3
                  }}-{{ invoiceAddresses[0].Zip }} {{ invoiceAddresses[0].City }}</v-list-item-content>
              </v-list-item>
              <v-list-item v-else>
                <v-list-item-content>{{ $t("views.overview.noPaymentAddress") }}</v-list-item-content>
              </v-list-item>
            </v-list>
            <br>
            <b>{{ $t("views.overview.deliveryAddress") }}</b>
            <v-skeleton-loader v-if="!masterOrderLoaded" type="list-item"></v-skeleton-loader>
            <v-list dense v-else>
              <v-list-item v-if="deliveryAddresses.length > 0">
                <v-list-item-icon>
                  <v-icon>mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{ deliveryAddresses[0].Street }}<br>{{
                  deliveryAddresses[0].Country.CountryCodeIso3 }}-{{ deliveryAddresses[0].Zip }} {{
                  deliveryAddresses[0].City }}</v-list-item-content>
              </v-list-item>
              <v-list-item v-else>
                <v-list-item-content>{{ $t("views.overview.noDeliveryAddress") }}</v-list-item-content>
              </v-list-item>
            </v-list>
            <br>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col lg="6" cols="12">
        <v-row>
          <v-col cols="12">
            <v-card class="" data-voverviewtourstep="2" elevation="0">
              <v-card-text>
                <h3 class="primary--text">
                  {{ $t("views.overview.yourAgent") }}
                </h3>
                <v-skeleton-loader v-if="!masterOrderLoaded" type="list-item-two-line" class="mt-3"></v-skeleton-loader>
                <v-list dense v-else>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon>mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      {{ masterOrder.Agent.DisplayName }}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="masterOrder.Agent.Email != undefined">
                    <v-list-item-icon>
                      <v-icon>mdi-email</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <a :href='"mailto:" + masterOrder.Agent.Email'>{{ masterOrder.Agent.Email }}</a>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="masterOrder.Agent.PhoneNumber != undefined">
                    <v-list-item-icon>
                      <v-icon>mdi-phone</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <a :href='"tel:" + masterOrder.Agent.PhoneNumber'>{{ masterOrder.Agent.PhoneNumber }}</a>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card class="" data-voverviewtourstep="3" elevation="0">
              <v-card-text>
                <h3 class="primary--text">
                  {{ $t("views.overview.contactAtLeeb") }}
                </h3>
                <v-skeleton-loader v-if="!masterOrderLoaded" type="list-item-two-line" class="mt-3"></v-skeleton-loader>
                <v-list dense v-else>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon>mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      {{ masterOrder.Clerk.DisplayName }}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="masterOrder.Clerk.Email != undefined">
                    <v-list-item-icon>
                      <v-icon>mdi-email</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <a :href='"mailto:" + masterOrder.Clerk.Email'>{{ masterOrder.Clerk.Email }}</a>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="masterOrder.Clerk.PhoneNumber != undefined">
                    <v-list-item-icon>
                      <v-icon>mdi-phone</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <a :href='"tel:" + masterOrder.Clerk.PhoneNumber'>{{ masterOrder.Clerk.PhoneNumber }}</a>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

    </v-row>

    <v-row>
      <v-col>

        <v-card elevation="0">
          <v-data-table :headers="workOrdersHeader" :items="filterCanceledWorkOrders(workOrders)"
            :loading="!workOrdersLoaded" :hide-default-footer="true" :hide-default-header="false" show-select
            single-select :item-key="'Id'" v-model="selectedWorkOrders"
            @click:row="(row, itemRow) => { itemRow.select(true); }">
            <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
              <v-simple-checkbox :value="isSelected" off-icon="" on-icon="mdi-play" color="primary" :ripple="false"
                @input="select($event)" />
            </template>
            <template v-slot:[`item.state`]="{ item }">
              <v-chip small>{{ translateStatus(calculateStatus(item)) }}</v-chip>
            </template>
            <template v-slot:[`item.delivery`]="{ item }">
              <span v-if="getDelivery(item) != null"><DeliveryInstallationDisplay :date="new Date(Date.parse(getDelivery(item)))"></DeliveryInstallationDisplay></span>
              <span v-else>&nbsp;</span>
            </template>
            <template v-slot:[`item.assembly`]="{ item }">
              <span v-if="getAssembly(item) != null"><DeliveryInstallationDisplay :date="new Date(Date.parse(getAssembly(item)))"></DeliveryInstallationDisplay></span>
              <span v-else>&nbsp;</span>
            </template>
            <template v-slot:[`item.actions`]="{ }">
              <v-icon @click="$router.push({path: '/messages'}).catch(() => {})">
                mdi-email-outline
              </v-icon>
            </template>
          </v-data-table>
        </v-card>

      </v-col>
    </v-row>

    <v-row v-if="showTimeLine">
      <v-col cols="12">
        <v-card elevation="0">
          <v-card-title>{{ $t("views.overview.timeline") }}</v-card-title>
          <v-card-text>
            <TimeLine :workOrderId="this.selectedWorkOrders[0].Id"></TimeLine>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-btn fab dark large color="primary" fixed right bottom @click="dialog.show = !dialog.show">
      <v-icon dark>mdi-email-fast</v-icon>
    </v-btn>
    <v-dialog v-model="dialog.show" max-width="500px">
      <v-card elevation="0">
        <v-card-title>{{ $t("views.overview.messageDialog.title") }}</v-card-title>
        <v-card-text>
          <v-text-field :value="dialog.receiver" outlined readonly :label="$t('views.overview.messageDialog.clerk')"></v-text-field>
          <v-textarea v-model="dialog.textdata" outlined>
            <template v-slot:label>
              <span>{{ $t("views.overview.messageDialog.text") }}</span>
            </template>
          </v-textarea>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="sendNewMessage()">{{ $t("views.overview.messageDialog.send") }}<v-icon right>mdi-send</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-tour name="VOverviewTour" :steps="vOverviewTourSteps"></v-tour>
  </ImageHeader>
</template>

<script>
import TimeLine from '../components/TimeLine.vue';
import ImageHeader from '../components/ImageHeader.vue';
import apiClient from '../plugins/CustomerPortalApiClient/client';
import { FieldOrderTypes } from '../plugins/CustomerPortalApiClient/types';
import DeliveryInstallationDisplay from '../components/DeliveryInstallationDisplay.vue';
import { HttpForbiddenError } from '../plugins/CustomerPortalApiClient/types';

export default {
  components: { TimeLine, ImageHeader, DeliveryInstallationDisplay },
  name: "Overview",
  data: () => ({
    masterOrder: {},
    masterOrderLoaded: false,
    workOrders: [],
    workOrdersLoaded: false,
    selectedWorkOrders: [],
    showTimeLine: false,
    orderStates: [],
    orderStatesLoaded: false,
    deliveryAddresses: [],
    invoiceAddresses: [],
    documentData: [],
    vOverviewTourSteps: [
      {
        target: '[data-voverviewtourstep="0"]',
        header: {
          title: 'Hier ist die Kopfzeile!',
        }
      },
      {
        target: '[data-voverviewtourstep="1"]',
        header: {
          title: 'Hier sind die Stammdaten ersichtlich!',
        },
        content: 'Ihre Daten, welche Sie uns mittgeteilt haben.'
      },
      {
        target: '[data-voverviewtourstep="2"]',
        header: {
          title: 'Der Verkäufer dieses Auftrags',
        }
      },
      {
        target: '[data-voverviewtourstep="3"]',
        header: {
          title: 'Der Sachbearbeiter dieses Auftrags',
        }
      },
      {
        target: '[data-voverviewtourstep="4"]',
        content: 'Die einzelnen Punkte in der Zeitleiste <i>sind</i> anklickbar!',
        params: {
          placement: 'top'
        }
      }
    ],
    token: "",
    dialog: {
      show: false,
      receiver: "",
      textdata: "",
    }
  }),
  mounted() {
    this.$tours['VOverviewTour'].start()
  },
  computed: {
    workOrdersHeader: {
      get() { return [
        { text: this.$t('views.overview.workOrdersHeader.orderNumber'), value: 'DisplayName', sortable: false, align: 'start' },
        { text: this.$t('views.overview.workOrdersHeader.article'), value: 'MainItemName', sortable: false },
        { text: this.$t('views.overview.workOrdersHeader.amount'), value: 'QuantityOrder', sortable: false },
        { text: this.$t('views.overview.workOrdersHeader.phase'), value: 'state', sortable: false },
        { text: this.$t('views.overview.workOrdersHeader.delivery'), value: 'delivery', sortable: false },
        { text: this.$t('views.overview.workOrdersHeader.installation'), value: 'assembly', sortable: false },
        { text: this.$t('views.overview.workOrdersHeader.actions'), value: 'actions', sortable: false },
      ];}
    }
  },
  methods: {
    filterCanceledWorkOrders: function (workOrders) {
      return apiClient.filterCanceledWorkOrders(workOrders);
    },
    getCustomerAddressation: function (customer) {
      let result = "";

      if (customer.Salutation != null) {
        result += customer.Salutation.Description + " ";
      }
      
      if (customer.Title != null) {
        result += customer.Title.Description + " ";
      }
      
      result += customer.FamilyName + " ";
      result += customer.FirstName;

      return result;
    },
    /**
     * Get the expected delivery date from the Tour's start date.
     * @returns {string} A Date
     */
    getDelivery: function (workOrder) {
      let deliveryTypeIds = [
        FieldOrderTypes.LK.Id,
        FieldOrderTypes.LL.Id,
        FieldOrderTypes.LM.Id
      ];

      let wofo = apiClient.getWorkOrderFieldOrdersFromWorkOrder(workOrder).find(x => x.FieldOrder && deliveryTypeIds.findIndex(y => y == x.FieldOrder.FieldOrderTypeId) != -1);
      if (wofo == null) {
        return null;
      }

      if (wofo.FieldOrder.Tour.StartDate != null) {
        return wofo.FieldOrder.Tour.StartDate;
      } else if (wofo.FieldOrder.Tour.CalendarWeek.DateFrom != null) {
        return wofo.FieldOrder.Tour.CalendarWeek.DateFrom;
      } else {
        return null;
      }
    },
    /**
     * Get the expected assembly date from the Tour's start date.
     * @returns {string} A Date
     */
    getAssembly: function (workOrder) {
      let assemblyTypeIds = [
        FieldOrderTypes.LM.Id,
        FieldOrderTypes.M.Id
      ];
      
      let wofo = workOrder.WorkOrderFieldOrders.find(x => x.FieldOrder && assemblyTypeIds.findIndex(y => y == x.FieldOrder.FieldOrderTypeId) != -1);
      if (wofo == null) {
        return null;
      }

      if (wofo.FieldOrder.Tour.StartDate != null) {
        return wofo.FieldOrder.Tour.StartDate;
      } else if (wofo.FieldOrder.Tour.CalendarWeek.DateFrom != null) {
        return wofo.FieldOrder.Tour.CalendarWeek.DateFrom;
      } else {
        return null;
      }
    },
    /**
     * Calculates the state of a given WorkOrder.
     * @return {Number} A number between 0 and 5
     */
    calculateStatus: function (workOrder) {
      let timeLineConfig = apiClient.calculateTimeLineConfig(workOrder.WorkOrderFieldOrders, workOrder.Events, workOrder.WorkOrderFlag, workOrder.IsInstallationOrder);

      // First orange ...
      let lastTimelinePhase = timeLineConfig.colors.findIndex((value) => value === "orange");

      // ... or last green.
      if(lastTimelinePhase === -1) {
        lastTimelinePhase = timeLineConfig.colors.lastIndexOf("green");
      }

      return lastTimelinePhase;
    },
    /**
     * Translates a given WorkOrder state to a name.
     * @returns {String} The coressponding name
     * @see calculateStatus
     */
    translateStatus: function (id) {
      switch(id) {
        case 0:
          return this.$t("views.overview.workOrderStates.orderReceival");
        case 1:
          return this.$t("views.overview.workOrderStates.measuring");
        case 2:
          return this.$t("views.overview.workOrderStates.designing");
        case 3:
          return this.$t("views.overview.workOrderStates.production");
        case 4:
          return this.$t("views.overview.workOrderStates.delivery");
        case 5:
          return this.$t("views.overview.workOrderStates.installation");
        default:
          return this.$t("views.overview.workOrderStates.unknown");
      }
    },
    sendNewMessage: function () {
      apiClient
      .createLisaMessageNew(
        this.$store.getters.token(),
        this.$store.getters.customerNumber(),
        this.masterOrder.Id,
        this.dialog.textdata
      ).then((success) => {
        if (success == false) {
          return;
        }
        this.dialog.show = false;
        this.$snackbar(this.$t("views.overview.success.newMessage"), 'green darken-1');
      }).catch((error) => {
        this.dialog.show = false;
        console.error(error);
        this.$snackbar(this.$t("views.overview.error.newMessage"), 'red darken-1');
      });
    },
    // #region data loading
    loadMasterOrderData: function () {
      apiClient
        .loadMasterOrder(
          this.$store.getters.token(),
          this.$store.getters.customerNumber(),
          this.$route.query.id
        ).then((masterOrder) => {
          this.masterOrder = masterOrder;
          this.masterOrderLoaded = true;
        }).catch((error) => {
          if (error instanceof HttpForbiddenError) {
            this.$router.push({path: '/error', query: { errorCode: 20403, targetRoute: this.$route.fullPath }}).catch(() => {})
            return;
          }

          console.error(error);
          this.$snackbar(this.$t("views.overview.error.loadMasterOrderData"), 'red darken-1');
        });
    },
    loadOrderStates: function () {
      apiClient.loadOrderStates(
        this.$store.getters.token()
      ).then((orderStates) => {
        this.orderStates = orderStates;
        this.orderStatesLoaded = true;
      }).catch((error) => {
        console.error(error);
        this.$snackbar(this.$t("views.overview.error.loadOrderStates"), 'red darken-1');
      });
    },
    loadWorkOrders: async function () {
      for (let i = 0; i < this.masterOrder.WorkOrders.length; i++) {
        await apiClient
        .loadWorkOrder(
          this.$store.getters.token(),
          this.$store.getters.customerNumber(),
          this.masterOrder.WorkOrders[i].Id
        ).then((workOrder) => {
          this.workOrders.push(workOrder);
        }).catch((error) => {
          console.error(error);
          this.$snackbar(this.$t("views.overview.error.loadWorkOrders"), 'red darken-1');
        });
      }
      this.workOrdersLoaded = true;
    },
    handleSelectedWorkOrderChanges: function () {
      if (this.selectedWorkOrders.length == 0) {
        this.showTimeLine = false;
      } else {
        this.showTimeLine = true;
      }
    }
  },
  created() {
    this.$store.commit('initFinished', false);

    this.$msal.getSilentToken(this.$msal.getAllAccounts()[0], [
      "offline_access",
      "openid",
      "https://leebcustomer.onmicrosoft.com/customerportal.api/Orders.Read",
    ]).then((rep) => {
      this.$store.commit('token', rep.accessToken);
      this.$store.commit('initFinished', true);
    }).catch(() => {
      this.$router.push({ path: "/logout" });
    });
  },
  watch: {
    '$store.state.initFinished': function(val) {
      if (val == true) {
        this.loadMasterOrderData();
      }
    },
    token() {
    },
    masterOrderLoaded() {
      this.loadOrderStates();
      this.deliveryAddresses = apiClient.getDeliveryAddresses(this.masterOrder.Customer.Addresses);
      this.invoiceAddresses = apiClient.getInvoiceAddresses(this.masterOrder.Customer.Addresses);
      this.dialog.receiver = this.masterOrder.Clerk.DisplayName;
      this.loadWorkOrders();
    },
    workOrdersLoaded() {
      this.selectedWorkOrders.push(this.masterOrder.WorkOrders.find(x => x.Id == this.masterOrder.Id));
    },
    selectedWorkOrders() {
      this.handleSelectedWorkOrderChanges();
    }
  }
};
</script>
